module.exports = __webpack_public_path__ + "img/digital_wire_bottom.48bd8d03.svg";